import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Send, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useSeo } from "@/lib/seo";
import { api, errMsg, formatDateTime } from "@/lib/api";
import { STATUS_LABEL, STRUCTURE_LABEL } from "@/lib/content";
import { Empty } from "@/components/kit";

export function Thread({ messages, mine = "visitor" }) {
  return (
    <ol className="space-y-4" data-testid="thread-messages">
      {messages.map((m) => {
        const own = m.author === mine;
        return (
          <li key={m.id} className={`flex ${own ? "justify-end" : "justify-start"}`}>
            <div className={`max-w-[85%] rounded-2xl px-5 py-3 ${own ? "rounded-br-sm bg-u text-white" : "rounded-bl-sm border border-black/5 bg-white"}`} data-testid={`thread-message-${m.author}`}>
              <p className={`text-xs font-semibold ${own ? "text-white/80" : "text-u"}`}>{m.author_name} · {formatDateTime(m.created_at)}</p>
              <p className="mt-1 whitespace-pre-line">{m.body}</p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}

export default function Conversation() {
  useSeo("Ma conversation", "Suivi de votre conversation avec MA LEBA.");
  const { token } = useParams();
  const [conv, setConv] = useState(undefined);
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    api.get(`/conversations/${token}`).then((r) => setConv(r.data)).catch(() => setConv(null));
  }, [token]);

  const send = async (e) => {
    e.preventDefault();
    if (!body.trim()) return;
    setLoading(true);
    try {
      const { data } = await api.post(`/conversations/${token}/reply`, { body });
      setConv(data);
      setBody("");
      toast.success("Message envoyé");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  if (conv === undefined) return <p className="container-x py-20">Chargement…</p>;
  if (conv === null) return <div className="container-x py-20"><Empty testid="conversation-not-found">Conversation introuvable. Vérifiez le lien reçu par e-mail.</Empty></div>;
  return (
    <section className="container-x max-w-3xl py-12" data-testid="conversation-page">
      <p className="eyebrow">Conversation · {STRUCTURE_LABEL[conv.structure]}</p>
      <h1 className="mt-2 font-display text-4xl font-bold uppercase text-ink sm:text-5xl">{conv.subject_label}</h1>
      <p className="mt-2 flex items-center gap-2 text-sm text-neutral-600">
        <ShieldCheck className="h-4 w-4 text-u" aria-hidden="true" /> Lien personnel et sécurisé — statut : <strong data-testid="conversation-status">{STATUS_LABEL[conv.status]}</strong>
      </p>
      <div className="card pagne mt-8 p-4 sm:p-6"><Thread messages={conv.messages} /></div>
      <form onSubmit={send} className="card mt-6 p-4 sm:p-6" data-testid="conversation-reply-form">
        <label htmlFor="reply" className="label">Votre réponse</label>
        <textarea id="reply" rows={4} className="input" value={body} onChange={(e) => setBody(e.target.value)} required data-testid="conversation-reply-input" />
        <button className="btn-u mt-4" disabled={loading} data-testid="conversation-reply-submit">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Répondre
        </button>
      </form>
    </section>
  );
}
